import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';
import ReactSlider from 'react-slick';

export default function bannerbox(props) {
  let slickSliderRef = useRef(null);
  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    autoplay: false,
    centerPadding: '5px',
    slidesToShow: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 377,
        settings: {
          centerMode: false,
          variableWidth: false,
        }
      },
      {
        breakpoint: 376,
        settings: {
          centerMode: true,
          variableWidth: true,
        }
      }
    ],
    appendDots: dots => (

      <ul style={{ margin: "0px" }}> {dots} </ul>

    ),
  };

  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  const handleClick_custom = (a,b,c,d) => {


    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음



    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: '홍보 배너',
        clickType: 'NC',
        value1: b.pc_img_attr,
        value2: '',
        value3: '',
        value4: '',
        value5: ''
      }
    });

  };


  try {
    if (props.data.contents.length == 1) {
      return (
        <>
          {/* {/*<!-- 화이트 배경 -->*/}
          <div className="mainContents-typeWhite" >

            {/*<!-- SBS PLAY 브랜드 -->*/}
            <div className="contentsBlock_w">
              <div className="moduleTitleline_w hide">
                <h2 className="moduleTitleline-Title">SBS PLAY 브랜드</h2>
              </div>
              <div className="SBSPLAY_Banner_w">
                <a href={props.data.contents[0].link_url}>
                  {/* <img
                src="https://via.placeholder.com/335x302"
                className="bnr_image"
                alt="배너광고영역"
              /> */}
                  <img src={props.data.contents[0].m_img_url} className="bnr_image" alt="배너광고영역" />
                </a>
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return (
        <>

          {/* {/*<!-- 화이트 배경 -->*/}
          <div className="mainContents-typeWhite" >
            {/*<!-- 하우스배너 리스트 -->*/}
            <div className="contentsBlock_w">

              {/*<!-- Swiper -->*/}
              <div className="houseBnrSwiperWrap">

                <ReactSlider className="swiper mySwiper variable-width" ref={slider => (slickSliderRef = slider)} {...settings}>
                  {
                    props.data.contents.map((item, index) => {
                      item.link_new_yn = 'N';
                      return (
                        item.m_view_yn === 'Y' ? (
                          <>
                            <div className="SliderContent swiper-wrapper">
                              <div className="listModuleItem swiper-slide">
                                <div className="moduleBoxWrap_houseBnr"
                                  style={{
                                    backgroundColor: `${item.bg_color_code}`
                                  }}
                                >
                                  <Link href={item.link_url}>
                                    <a  onClick={(e) => handleClick_custom(e, item,'0','all')}  target={item.link_new_yn === 'Y' ? '_blank' : ''} href={item.link_url} className="mb_link">
                                      <img src={item.m_img_url} className="mb_image" alt={item.m_img_attr} />
                                    </a>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : (<></>)
                      )
                    })
                  }
                </ReactSlider>
                {/* <div className="slick-dots"></div> */}
              </div>
            </div>
          </div >
        </>
      );
    }
  } catch (error) {
    return (<></>);
  }

}